import axiosInstance from "./axios-instance-api";

const getHttpOnlyCookie = async (idToken, email) => {
	return axiosInstance().post(`/cookie`, { idToken, email }, { withCredentials: true });
}

const deleteHttpOnlyCookie = async () => {
    return axiosInstance().delete( `/cookie/delete`, { withCredentials: true })
}

const CookieAPI = {
    getHttpOnlyCookie,
    deleteHttpOnlyCookie
};

export default CookieAPI;